export const GET_PRODUCT_COUNTDOWN_TIMER_ENDPOINT = '/Catalog/GetProductCountdownTimer?productPageId=';
